import * as types from 'model/actionTypes'
import { AnyAction } from 'redux'
import { UserT } from 'model/types'

const initialState: UserT | null = null

export default function user (state = initialState, action: AnyAction) {
  switch (action.type) {
    case types.RECEIVE_USER:
      return action.user
    case types.LOGOUT:
      return initialState
    default:
      return state
  }
}
